// LIST
export const FETCH_NOTIFICATION = "app/NOTIFICATION/FETCH_NOTIFICATION";
export const FETCH_NOTIFICATION_SUCCESS =
  "app/NOTIFICATION/FETCH_NOTIFICATION_SUCCESS";
export const FETCH_NOTIFICATION_FAILURE =
  "app/NOTIFICATION/FETCH_NOTIFICATION_FAILURE";

export const ADD_NOTIFICATION = "app/NOTIFICATION/ADD_NOTIFICATION";
export const ADD_NOTIFICATION_SUCCESS =
  "app/NOTIFICATION/ADD_NOTIFICATION_SUCCESS";
export const ADD_NOTIFICATION_FAILURE =
  "app/NOTIFICATION/ADD_NOTIFICATION_FAILURE";

export const TOGGLE_NOTI_MODAL = "app/NOTIFICATION/TOGGLE_NOTI_MODAL";
